import { Component } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { PropgService } from 'src/app/services/propg-service'

type TabState = 'inicial' | 'desatualizada' | 'carregando' | 'pronto' | 'sem_resultado'

@Component({
  selector: 'app-pesquisa-usuario',
  templateUrl: './pesquisa-usuario.component.html',
  styleUrls: ['./pesquisa-usuario.component.css'],
  standalone: false
})
export class PesquisaUsuarioComponent {
  lastSearch: string = ''

  dataCentral?: any
  dataRH?: any
  dataPos: any[] = []

  tabStateCentral: TabState = 'inicial'
  tabStateRH: TabState = 'inicial'
  tabStatePos: TabState = 'inicial'

  form = new FormGroup({
    cpf: new FormControl('', Validators.required),
  })

  constructor(private propgService: PropgService) {}

  getDataCentral(): TabState {
    if (this.tabStateCentral !== 'desatualizada') return this.tabStateCentral

    this.tabStateCentral = 'carregando'
    this.propgService.usuarioCentral(this.form.controls['cpf'].getRawValue()!).subscribe(data => {
      this.dataCentral = data
      this.tabStateCentral = data ? 'pronto' : 'sem_resultado'
    })
    this.dataCentral = [{ horario: new Date() }]

    return 'carregando'
  }

  getDataRH(): TabState {
    if (this.tabStateRH !== 'desatualizada') return this.tabStateRH

    this.tabStateRH = 'carregando'
    this.propgService.usuarioRH(this.form.controls['cpf'].getRawValue()!).subscribe(data => {
      this.dataRH = data
      this.tabStateRH = data ? 'pronto' : 'sem_resultado'
    })
    this.dataRH = [{ horario: new Date() }]

    return this.tabStateRH
  }

  getDataPos(): TabState {
    if (this.tabStatePos !== 'desatualizada') return this.tabStatePos

    this.tabStatePos = 'carregando'
    this.propgService.usuarioPos(this.form.controls['cpf'].getRawValue()!).subscribe(data => {
      this.dataPos = data
      this.tabStatePos = data.length > 0 ? 'pronto' : 'sem_resultado'
    })
    this.dataPos = [{ horario: new Date() }]

    return this.tabStatePos
  }

  filtrar() {
    if (this.form.controls['cpf'].getRawValue()!.length === 11) {
      this.lastSearch = this.form.controls['cpf'].getRawValue()!
      this.tabStateCentral = this.tabStateRH = this.tabStatePos = 'desatualizada'
    }
  }
}
